import { useState, useEffect } from "react";
import { FileText, Users, Briefcase, ChevronRight, CheckCircle, Sparkles, Cpu, Cloud, Shield, Server, Brain, Database } from 'lucide-react';
import Swal from "sweetalert2";
import Backend from "../../Backend/Backend";

const partners = [
    {
        name: "Google",
        color: "hover:text-[#4285F4]",
        colorCode: "#4285F4",
        logo: (
            <svg className="h-7 w-auto" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12.24 10.285V14.4h6.887c-.648 2.41-2.519 4.114-5.136 4.114A5.72 5.72 0 0 1 8.24 12.8a5.72 5.72 0 0 1 5.751-5.714c2.404 0 4.364 1.547 5.093 3.657l3.874-3.003C20.89 4.09 17.65 2 13.99 2 8.02 2 3.19 6.83 3.19 12.8s4.83 10.8 10.8 10.8c5.96 0 10.8-4.83 10.8-10.8 0-.82-.093-1.614-.26-2.385H12.24z"/>
            </svg>
        )
    },
    {
        name: "Microsoft",
        color: "hover:text-[#F25022]",
        colorCode: "#F25022",
        logo: (
            <svg className="h-6 w-auto" viewBox="0 0 23 23" fill="currentColor">
                <rect x="0" y="0" width="10.5" height="10.5" fill="#f25022"/>
                <rect x="11.5" y="0" width="10.5" height="10.5" fill="#7fba00"/>
                <rect x="0" y="11.5" width="10.5" height="10.5" fill="#00a4ef"/>
                <rect x="11.5" y="11.5" width="10.5" height="10.5" fill="#ffb900"/>
            </svg>
        )
    },
    {
        name: "Dell",
        color: "hover:text-[#0076CE]",
        colorCode: "#0076CE",
        logo: (
            <svg className="h-6 w-auto" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-3.31 0-6-2.69-6-6 0-.61.1-1.2.29-1.76l1.36.46c-.4.82-.65 1.74-.65 2.71 0 2.54 1.79 4.67 4.19 5.17l.41-1.41c-1.6-.33-2.81-1.66-3.05-3.32h1.69c.14.77.56 1.42 1.18 1.83l.84-.71c-.34-.23-.62-.57-.79-.97h2.95v-.95h-3.05c-.01-.08-.02-.17-.02-.25v-.31h3.07v-.95H9.37V11h3.05v-.95H9.72c.17-.4.45-.74.79-.97l-.84-.71c-.62.41-1.04 1.06-1.18 1.83H6.84C7.08 7.55 8.29 6.22 9.89 5.9l-.41-1.41C7.08 4.98 5.29 7.12 5.29 9.66c0 .97.25 1.89.65 2.71l-1.36.46C4.4 12.27 4.3 11.68 4.3 11c0-4.25 3.45-7.7 7.7-7.7s7.7 3.45 7.7 7.7c0 .68-.1 1.27-.29 1.83l-1.36-.46c.4-.82.65-1.74.65-2.71 0-2.54-1.79-4.67-4.19-5.17l-.41 1.41c1.6.33 2.81 1.66 3.05 3.32h-1.69c-.14-.77-.56-1.42-1.18-1.83l-.84.71c.34.23.62.57.79.97h-2.95v.95h3.05c.01.08.02.17.02.25v.31h-3.07v.95h3.05v.95h-3.05v.95h3.69c-.17.4-.45.74-.79.97l.84.71c.62-.41 1.04-1.06 1.18-1.83h1.69c-.24 2.11-1.45 3.44-3.05 3.76l.41 1.41c2.4-.5 4.19-2.63 4.19-5.17 0-.97-.25-1.89-.65-2.71l1.36-.46c.19.56.29 1.15.29 1.76 0 4.25-3.45 7.7-7.7 7.7z"/>
            </svg>
        )
    },
    {
        name: "Intel",
        color: "hover:text-[#0071C5]",
        colorCode: "#0071C5",
        logo: (
            <svg className="h-6 w-auto" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 1.5c4.7 0 8.5 3.8 8.5 8.5S16.7 20.5 12 20.5 3.5 16.7 3.5 12 7.3 3.5 12 3.5zm-5 11h1.5v-3.5h-1.5v3.5zm0-4.5h1.5v-1.5h-1.5v1.5zm2.5 4.5h1.5v-2c0-.5.2-.8.6-.8s.6.3.6.8v2h1.5v-2.3c0-1.1-.6-1.7-1.5-1.7-.6 0-1.1.3-1.3.8h-.1v-.6h-1.3v3.8zm6.5 0h1.5v-3h1v-1h-1v-1h-1.5v1h-.5v1h.5v3zm3.5 0h2.5v-1H21v-1.2h1v-1h-1v-.8c0-.5.2-.8.6-.8h.4v-1h-.6c-1 0-1.6.6-1.6 1.5v1.1h-.8v1h.8v2.2z"/>
            </svg>
        )
    },
    {
        name: "AWS",
        color: "hover:text-[#FF9900]",
        colorCode: "#FF9900",
        logo: (
            <svg className="h-6 w-auto" viewBox="0 0 24 24" fill="currentColor">
                <path d="M6.2 13.5c-.8 0-1.5-.2-2-.6-.4-.3-.6-.8-.6-1.4 0-.7.3-1.2.9-1.5.6-.3 1.5-.5 2.7-.5h1V9c0-.6-.1-1-.4-1.2-.3-.2-.8-.4-1.5-.4-.7 0-1.3.1-1.9.4l-.4-.8c.8-.4 1.7-.6 2.6-.6 1.1 0 1.9.3 2.4.8.5.5.7 1.3.7 2.4v4h-1v-.8c-.4.6-1.1.9-2 .9zm.8-.9c.6 0 1.1-.2 1.4-.6.3-.4.5-.9.5-1.5v-.5h-.9c-.9 0-1.5.1-1.9.3-.4.2-.5.5-.5.9 0 .4.1.7.4.9.2.3.6.5 1 .5zm8-3.4l.9 3.2.9-3.2h1.2l.9 3.2.9-3.2h1.2l-1.5 4.8h-1.2l-.9-3.2-.9 3.2h-1.2l-1.5-4.8h1.2zm6.9 3.8c0 .4.2.6.6.6.3 0 .6-.1.9-.3l.3.8c-.4.3-.9.5-1.5.5-.7 0-1.2-.2-1.5-.6-.3-.4-.5-1-.5-1.8 0-.9.2-1.6.6-2.1.4-.5 1-.8 1.8-.8.7 0 1.2.2 1.5.7.3.5.5 1.1.5 2h-3.9v.4c.1.4.2.7.5.9.2.2.5.3.7.3zm-.1-2.4c-.3 0-.5.1-.6.4-.1.3-.2.6-.2 1h1.9c0-.4-.1-.7-.2-.9l-.3-.4c-.1-.1-.3-.1-.6-.1zM4 16.5c2.7 1.8 6.3 2.8 9.9 2.8 4 0 7.8-1.2 10.9-3.4.3-.2.5 0 .2.3-2.9 2.5-6.9 3.9-11.2 3.9-3.9 0-7.8-1.2-10.7-3.3-.3-.2-.1-.5.2-.3zm19.2.3c-.2.2-1 .1-1.4-.1-.4-.1-.4-.6-.2-.7.2-.2.9.1 1.2.3.3.1.6.3.4.5zm-.8-.9c-.1-.2.4-.9.7-1.1.2-.2.6 0 .5.3-.2.3-.9.9-1.2.8z"/>
            </svg>
        )
    },
    {
        name: "Cisco",
        color: "hover:text-[#00BCEB]",
        colorCode: "#00BCEB",
        logo: (
            <svg className="h-6 w-auto" viewBox="0 0 24 24" fill="currentColor">
                <rect x="2" y="11" width="1.5" height="4" rx="0.75" />
                <rect x="5" y="8" width="1.5" height="7" rx="0.75" />
                <rect x="8" y="5" width="1.5" height="10" rx="0.75" />
                <rect x="11" y="2" width="1.5" height="13" rx="0.75" />
                <rect x="14" y="5" width="1.5" height="10" rx="0.75" />
                <rect x="17" y="8" width="1.5" height="7" rx="0.75" />
                <rect x="20" y="11" width="1.5" height="4" rx="0.75" />
            </svg>
        )
    },
    {
        name: "Apple",
        color: "hover:text-[#000000] dark:hover:text-[#FFFFFF]",
        colorCode: "#000000",
        logo: (
            <svg className="h-6 w-auto" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.82M15.97 4.17c.66-.81 1.11-1.93.99-3.06-.96.04-2.13.64-2.82 1.45-.6.69-1.12 1.83-.98 2.94 1.07.08 2.15-.52 2.81-1.33z"/>
            </svg>
        )
    },
    {
        name: "HP",
        color: "hover:text-[#0096D6]",
        colorCode: "#0096D6",
        logo: (
            <svg className="h-6 w-auto" viewBox="0 0 24 24" fill="currentColor">
                <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2" />
                <path d="M9 7v10h1.5v-4H13v4h1.5V7H13v4h-2.5V7H9z" />
            </svg>
        )
    }
];

export default function Home() {

    const [open, setOpen] = useState(false);
    const [backend, setBackend] = useState(null);
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("career");

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        file: null
    });

    // ✅ Init backend
    useEffect(() => {
        const initBackend = async () => {
            const b = await new Backend().init();
            setBackend(b);
        };
        initBackend();
    }, []);

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "file") {
            setFormData({ ...formData, file: files[0] });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    // ✅ Submit
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!backend) return;

        setLoading(true); // 🔥 START LOADING

        const data = new FormData();
        data.append("name", formData.name);
        data.append("email", formData.email);
        data.append("mobile", formData.mobile);
        data.append("file", formData.file);

        // ✅ Show loading popup
        Swal.fire({
            title: 'Sending...',
            text: 'Please wait',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const res = await backend.consultation(data);

            Swal.close(); // ✅ close loader

            if (res.error === "False") {
                Swal.fire({
                    icon: "success",
                    title: "Booked Successfully 🚀",
                    text: "Our team will contact you soon.",
                    confirmButtonColor: "#6366f1"
                });

                setFormData({
                    name: "",
                    email: "",
                    mobile: "",
                    file: null
                });

                setOpen(false)

            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Failed',
                    text: res.message || 'Failed to send ❌',
                });
            }

        } catch (err) {
            console.error(err);

            Swal.close();

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Something went wrong ❌',
            });
        } finally {
            setLoading(false);
        }
    };



    // ✅ Smooth scroll with navbar offset
    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        const offset = 80;

        if (element) {
            const top = element.offsetTop - offset;
            window.scrollTo({
                top,
                behavior: 'smooth'
            });
        }
    };

    return (
        <div className="relative min-h-screen bg-brand-light text-slate-900 font-sans overflow-hidden">

            {/* GLOBAL RADIAL BACKGROUND */}
            <div className="absolute inset-0 bg-brand-radial -z-10"></div>

            {/* HERO SECTION */}
            <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden">

                {/* Gradient Glow Background */}
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full -z-10 pointer-events-none">
                    <div className="absolute top-[-10%] left-[10%] w-[500px] h-[500px] bg-brand-primary/40 rounded-full blur-[120px] animate-pulse"></div>
                    <div className="absolute bottom-[10%] right-[10%] w-[400px] h-[400px] bg-brand-accent/30 rounded-full blur-[100px]"></div>
                </div>

                <div className="max-w-7xl mx-auto px-6 text-center">

                    {/* Badge */}
                    <div className="inline-flex items-center gap-2 px-4 py-1.5 mb-8 text-sm font-bold tracking-wide text-brand-dark uppercase bg-brand-light border border-brand-primary/30 rounded-full">
                        <Sparkles size={14} />
                        Your Gateway to Tech Roles
                    </div>

                    {/* Heading */}
                    <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-8xl font-black mb-6 leading-tight tracking-tight">
                        Build Your Career with{" "}
                        <span className="block sm:inline bg-brand-gradient bg-clip-text text-transparent">
                            Genius Bridge Technologies
                        </span>
                    </h1>

                    {/* Subtitle */}
                    <p className="max-w-2xl mx-auto mb-12 text-lg lg:text-2xl text-slate-600 font-medium leading-relaxed">
                        We bridge the gap between talent and opportunity with expert-led training and ATS-optimized resumes.
                    </p>

                    {/* Buttons */}
                    <div className="flex flex-col sm:flex-row justify-center items-center gap-5">

                        {/* ✅ UPDATED BUTTON */}
                        <button
                            onClick={() => setOpen(true)}
                            className="group w-full sm:w-auto flex items-center justify-center gap-3 bg-brand-dark text-white px-10 py-5 rounded-2xl font-bold text-lg hover:bg-brand-primary shadow-2xl shadow-brand-primary/30 transition-all duration-300 active:scale-95"
                        >
                            <FileText size={22} className="group-hover:rotate-12 transition-transform" />
                            Book Consultation
                        </button>

                        <button onClick={() => scrollToSection('careers')} className="w-full sm:w-auto flex items-center justify-center gap-2 bg-white border border-brand-primary/20 px-10 py-5 rounded-2xl font-bold text-lg hover:border-brand-primary hover:text-brand-primary transition-all shadow-sm">
                            Explore Jobs
                            <ChevronRight size={20} />
                        </button>
                    </div>

                    {/* Social Proof */}
                    <div className="mt-16 flex flex-col items-center gap-4">
                        <div className="flex -space-x-4">
                            {[1, 2, 3, 4, 5].map((i) => (
                                <img
                                    key={i}
                                    src={`https://i.pravatar.cc/100?u=gb${i}`}
                                    alt="user"
                                    className="w-12 h-12 rounded-full border-4 border-white shadow-sm object-cover"
                                />
                            ))}
                        </div>
                        <p className="text-slate-500 font-medium">
                            <span className="text-slate-900 font-bold">2,000+</span> professionals landed roles this month
                        </p>
                    </div>
                </div>
            </section>

            {/* BRAND PARTNERS / LOGO SHOWCASE */}
            <section className="py-12 bg-white/45 border-y border-slate-200/50 backdrop-blur-md relative z-10">
                <div className="max-w-7xl mx-auto px-6">
                    <p className="text-center text-xs font-bold uppercase tracking-widest text-slate-400 mb-8">
                        Ecosystem Partners & Technologies We Support
                    </p>
                    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-8 items-center justify-items-center">
                        {partners.map((partner, index) => (
                            <div
                                key={index}
                                className={`flex flex-col items-center gap-2 text-slate-400 hover:scale-110 transition-all duration-300 ${partner.color} cursor-pointer`}
                                title={partner.name}
                            >
                                {partner.logo}
                                <span className="text-xs font-semibold tracking-wider uppercase mt-1 opacity-75">{partner.name}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* SERVICES SECTION */}
            <section className="py-24 relative">
                <div className="max-w-7xl mx-auto px-6">

                    <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
                        <div className="max-w-2xl">
                            {activeTab === "career" ? (
                                <>
                                    <h2 className="text-4xl lg:text-5xl font-black text-slate-900 mb-6">
                                        Everything you need to <span className="text-brand-primary">get hired.</span>
                                    </h2>
                                    <p className="text-xl text-slate-500">
                                        Specialized career solutions that outperform traditional job hunting.
                                    </p>
                                </>
                            ) : (
                                <>
                                    <h2 className="text-4xl lg:text-5xl font-black text-slate-900 mb-6">
                                        Enterprise <span className="text-brand-primary">IT & Software</span> Services
                                    </h2>
                                    <p className="text-xl text-slate-500">
                                        Empowering businesses with cutting-edge tech integration and management.
                                    </p>
                                </>
                            )}
                        </div>
                    </div>

                    {/* Tab Switcher */}
                    <div className="flex justify-center mb-16">
                        <div className="bg-white/60 backdrop-blur-md p-1.5 rounded-2xl border border-slate-200/50 inline-flex gap-2 shadow-sm">
                            <button
                                onClick={() => setActiveTab("career")}
                                className={`px-6 py-3 rounded-xl font-bold text-sm transition-all duration-300 ${
                                    activeTab === "career"
                                        ? "bg-brand-dark text-white shadow-md"
                                        : "text-slate-600 hover:text-slate-900"
                                }`}
                            >
                                Career Bridging
                            </button>
                            <button
                                onClick={() => setActiveTab("it")}
                                className={`px-6 py-3 rounded-xl font-bold text-sm transition-all duration-300 ${
                                    activeTab === "it"
                                        ? "bg-brand-dark text-white shadow-md"
                                        : "text-slate-600 hover:text-slate-900"
                                }`}
                            >
                                Enterprise IT Services
                            </button>
                        </div>
                    </div>

                    {activeTab === "career" ? (
                        <div className="grid md:grid-cols-3 gap-8">
                            <ServiceCard
                                icon={<FileText size={32} />}
                                title="Resume Optimization"
                                desc="Our experts transform your CV into an ATS-friendly masterpiece that captures attention."
                                color="primary"
                                features={["Keyword Optimization", "Professional Formatting"]}
                            />

                            <ServiceCard
                                icon={<Users size={32} />}
                                title="Interview Training"
                                desc="Practice with industry veterans through mock interviews tailored to your specific field."
                                color="dark"
                                features={["Live Mock Sessions", "Body Language Coaching"]}
                            />

                            <ServiceCard
                                icon={<Briefcase size={32} />}
                                title="Job Placement"
                                desc="Access our exclusive network of hiring partners. We find the right fit for you."
                                color="accent"
                                features={["Direct Referrals", "Salary Negotiation"]}
                            />
                        </div>
                    ) : (
                        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                            <ServiceCard
                                icon={<Cpu size={32} />}
                                title="Software & App Dev"
                                desc="End-to-end engineering of custom web portals and cross-platform mobile apps using modern tech stacks."
                                color="blue"
                                features={["Web & Mobile Engineering", "React / Node.js / Next.js", "Scalable System Architecture"]}
                            />

                            <ServiceCard
                                icon={<Cloud size={32} />}
                                title="Cloud & DevOps"
                                desc="Robust hosting setups, automated CI/CD deployment pipelines, containerization, and AWS/Azure/GCP hosting."
                                color="indigo"
                                features={["AWS / Azure Migrations", "Kubernetes & Docker", "Automated Infrastructure"]}
                            />

                            <ServiceCard
                                icon={<Shield size={32} />}
                                title="Cybersecurity & Audits"
                                desc="Proactive threat mitigation, penetration testing, security reviews, and SOC2/GDPR compliance mapping."
                                color="rose"
                                features={["Penetration Testing", "Security Auditing", "Data Encryption Standards"]}
                            />

                            <ServiceCard
                                icon={<Server size={32} />}
                                title="Managed IT Support"
                                desc="Proactive server monitoring, network engineering, database administration, and IT consulting."
                                color="cyan"
                                features={["24/7 Operations Support", "Database Administration", "Strategic Tech Advisory"]}
                            />

                            <ServiceCard
                                icon={<Brain size={32} />}
                                title="AI & Machine Learning"
                                desc="Harness machine learning models, custom AI chatbot builds, data analysis tools, and LLM integrations."
                                color="primary"
                                features={["Large Language Models", "Automated Analytics", "Intelligent Chatbots"]}
                            />

                            <ServiceCard
                                icon={<Database size={32} />}
                                title="Data Engineering & APIs"
                                desc="Database administration, data warehousing, secure ETL pipelines, and high-performance REST/GraphQL API systems."
                                color="accent"
                                features={["Database Tuning", "ETL & ETL Pipelines", "Custom API Integrations"]}
                            />
                        </div>
                    )}
                </div>
            </section>

            {/* ✅ MODAL */}
            {open && (
                <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">

                    <div className="bg-white rounded-2xl p-8 w-full max-w-md relative shadow-2xl">

                        <button
                            onClick={() => setOpen(false)}
                            className="absolute top-3 right-3 text-gray-400 hover:text-black"
                        >
                            ✕
                        </button>

                        <h2 className="text-2xl font-bold mb-6 text-center">
                            Book Consultation
                        </h2>

                        <form onSubmit={handleSubmit} className="space-y-5">

                            <input
                                type="text"
                                name="name"
                                placeholder="Your Name"
                                required
                                onChange={handleChange}
                                className="w-full px-4 py-3 rounded-xl border border-gray-200"
                            />

                            <input
                                type="email"
                                name="email"
                                placeholder="Your Email"
                                required
                                onChange={handleChange}
                                className="w-full px-4 py-3 rounded-xl border border-gray-200"
                            />

                            <input
                                type="tel"
                                name="mobile"
                                placeholder="Mobile Number"
                                required
                                onChange={handleChange}
                                className="w-full px-4 py-3 rounded-xl border border-gray-200"
                            />

                            <input
                                type="file"
                                name="file"
                                required
                                onChange={handleChange}
                                className="w-full px-4 py-3 rounded-xl border border-gray-200"
                            />

                            <button
                                type="submit"
                                disabled={loading}
                                className={`w-full py-3 rounded-xl font-bold text-white flex items-center justify-center gap-2 transition
        ${loading ? "bg-gray-400 cursor-not-allowed" : "bg-brand-gradient hover:opacity-90"}
    `}
                            >
                                {loading ? (
                                    <>
                                        <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                                        Processing...
                                    </>
                                ) : (
                                    "Submit & Book"
                                )}
                            </button>

                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

/* ❌ NOT MODIFIED (as you requested) */
function ServiceCard({ icon, title, desc, color, features }) {

    const colorMap = {
        primary: "bg-brand-light text-brand-primary group-hover:bg-brand-primary",
        accent: "bg-pink-50 text-brand-accent group-hover:bg-brand-accent",
        dark: "bg-purple-100 text-brand-dark group-hover:bg-brand-dark",
        blue: "bg-blue-50 text-blue-600 group-hover:bg-blue-600",
        indigo: "bg-indigo-50 text-indigo-600 group-hover:bg-indigo-600",
        rose: "bg-rose-50 text-rose-600 group-hover:bg-rose-600",
        cyan: "bg-cyan-50 text-cyan-600 group-hover:bg-cyan-600"
    };

    return (
        <div className="group p-10 backdrop-blur-xl bg-white/60 border border-white/40 rounded-[2rem] hover:translate-y-[-8px] transition-all duration-500 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_50px_rgba(156,39,176,0.2)]">

            <div className={`w-16 h-16 rounded-2xl flex items-center justify-center mb-8 transition-all duration-300 ${colorMap[color]} group-hover:text-white group-hover:scale-110`}>
                {icon}
            </div>

            <h3 className="text-2xl font-bold mb-4 text-slate-900">{title}</h3>

            <p className="text-slate-500 mb-8 leading-relaxed text-lg">
                {desc}
            </p>

            <div className="space-y-3">
                {features.map((feat, index) => (
                    <div key={index} className="flex items-center gap-3 text-sm font-semibold text-slate-600">
                        <div className="bg-brand-light p-0.5 rounded-full">
                            <CheckCircle size={16} className="text-brand-primary" />
                        </div>
                        {feat}
                    </div>
                ))}
            </div>
        </div>
    );
}